import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Observable } from 'rxjs';
import { DadosFormService } from '../doador/doador.service';


@Injectable({providedIn:'root'})
export class DadosFormResolver implements Resolve<Observable<any>>{
    constructor(
        private dadosCadastraisService: DadosFormService
    ){}

    resolve(route:ActivatedRouteSnapshot,state:RouterStateSnapshot):Observable<any>{
        let idDoador = route.paramMap.get("idDoador");
        return this.dadosCadastraisService.getUserByID(idDoador);
    }
}